import { newTracker } from '@snowplow/browser-tracker'
import {
  PsykheSnowplowEcommercePlugin,
  seedSnowplowDomainUserId,
  setEcommerceUser,
  trackProductView,
  trackProductListView,
  trackListClick,
  trackAddToCart,
  trackTransaction,
} from '@psykhe-ai/browser-plugin-snowplow-ecommerce';
import $ from 'jquery';

let tracker;

function initTracker() {
  if (!window.rcProps.enablePsykheTracking) {
    tracker = null;
  }

  if (tracker === undefined) {
    const PSYKHE_BASE_URL = 'https://api.psykhe.dev';
    const POST_PATH = '/v1/collector';
    const clientIdentifier = 'fwrd';
    const cookieName = '_psykhe_';
    const cookieDomain = document.location.hostname;
    const stateStorageStrategy = 'cookieAndLocalStorage';
    const {seeded} = seedSnowplowDomainUserId(window.rcProps.browserId, {
      cookieName,
      cookieDomain,
      stateStorageStrategy,
    });

    tracker = newTracker('psykhe-ai', PSYKHE_BASE_URL, {
      appId: clientIdentifier,
      appVersion: '1.0.0',
      postPath: POST_PATH,
      cookieName: '_psykhe_',
      cookieDomain: document.location.hostname,
      stateStorageStrategy: 'cookieAndLocalStorage',
      cookieSecure: true,
      cookieSameSite: 'Lax',
      keepalive: true,
      credentials: 'include',
      bufferSize: 1,
      contexts: {
        session: true, // mandatory session context
        webPage: true, // optional
        browser: true // optional
      },
      plugins: [PsykheSnowplowEcommercePlugin()]
    });

    setEcommerceUser({
      is_guest: window.rcProps.isGuest,
      id: window.rcProps.userId,
    });
  }

  return tracker;
}

export const trackPsykhePdpView = (code, name, price) => {
  if (initTracker()) {
    trackProductView({
      product_id: code,
      variant_id: code,
      name: name,
      price: price,
      currency: 'USD',
    });
  }
}

export const trackPsykhePlpView = () => {
  if (initTracker()) {
    trackProductListView({
      name: window.rcProps.plp.psykheCategory,
      products: $('.js-plp-container').toArray().map((el, index) => {
        const $el = $(el);
        const code = $el.attr('id');
        return {
          product_id: code,
          variant_id: code,
          name: $el.data('product-name'),
          price: parseFloat($el.data('priceUsd')),
          currency: 'USD',
          position: index + 1,
        }
      })
    })
  }
}

export const trackPsykhePlpClick = ($plpContainer) => {
  if (initTracker()) {
    trackListClick({
      productList: window.rcProps.plp.psykheCategory,
      product: {
        product_id: $plpContainer.attr('id'),
        variant_id: $plpContainer.attr('id'),
        name: $plpContainer.data('product-name'),
        price: parseFloat($plpContainer.data('priceUsd')),
        currency: 'USD',
        position: [...$plpContainer.parent().children()].indexOf($plpContainer[0]) + 1,
      },
    })
  }
}

export const trackPsykheAddToCart = (code, atbResponse) => {
  if (initTracker()) {
    trackAddToCart({
      cart_id: window.rcProps.browserId,
      total_value: parseFloat(atbResponse.msg33),
      currency: 'USD',
      products: [{
        product_id: code,
        variant_id: code,
        name: atbResponse.msg31,
        price: parseFloat(atbResponse.msg15),
        currency: 'USD',
        quantity: 1
      }],
    });
  }
}

export const trackPsykheTransaction = (transaction) => {
  if (initTracker()) {
    trackTransaction(transaction);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/psykhe.js